import { ShapingService } from '../../../../services';
import { LinePriceDetails } from '../../../../components/lines-editor/base-doc-line-editor/base-doc-line-editor';
import { CommonModule } from '@angular/common';
import { Component, Injector, Input, output, ViewChild } from '@angular/core';
import { LocalizationService, LocalizationModule } from '@abp/ng.core';
import { ColDef } from '@ag-grid-community/core';
import {
  CustomerQuoteDto,
  CustomerQuoteService,
  DocLineRole,
  DocLineUpdatedDto,
} from '@digiwall/goliath-documents/proxy';
import { LinesEditorComponent } from '../../../../components';

import { ObserverQueue } from '@digiwall/core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { BaseCustomerDocLineEditor } from '../../../base-customer-docs/lines/base-customer-doc-lines-editor.component';

@Component({
  selector: 'document-quote-lines-grid',
  templateUrl: './quote-lines-editor.component.html',
  imports: [CommonModule, LinesEditorComponent, LocalizationModule],
  providers: [ObserverQueue],
})
export default class QuoteLinesEditorComponent extends BaseCustomerDocLineEditor<CustomerQuoteDto> {
  @ViewChild('lineGrid') lineGrid: LinesEditorComponent;
  @Input() set customerQuote(value) {
    this._document = value;
    this.setLanguageCode();
  }

  @Input() set readonly(value) {
    this._readonly = value;
  }
  public override lineUpdatedEvent = output<Partial<DocLineUpdatedDto>>();
  public linePricingDetailsEvent = output<LinePriceDetails>();
  public actionBtns = [];

  protected override handlingLinesUpdatedEvent = true;

  protected override articleLineRole: DocLineRole = DocLineRole.CustomerQuoteArticle;
  protected override textLineRole: DocLineRole = DocLineRole.CustomerDocText;
  protected override chapterLineRole: DocLineRole = DocLineRole.DocChapter;

  protected override articleLookupFn = (term: string) =>
    this.articleService.getArticleSellableSelectionLookup(term);

  protected computationModuleActive: boolean = false;

  constructor(
    protected localizationService: LocalizationService,
    protected docService: CustomerQuoteService,
    protected shapingService: ShapingService,
    protected injector: Injector,
    protected updateQueue: ObserverQueue,
    protected confirmationService: ConfirmationService,
  ) {
    super(
      localizationService,
      docService,
      shapingService,
      injector,
      updateQueue,
      confirmationService,
    );

    this.actionBtns = [{ ...this.getPrintActionButton(), visibleInReadonly: true }];
    this.initColDefs();
  }
}
